import { render } from "./VenueIncidentPanel.vue?vue&type=template&id=2307bce3&scoped=true"
import script from "./VenueIncidentPanel.vue?vue&type=script&lang=js"
export * from "./VenueIncidentPanel.vue?vue&type=script&lang=js"

import "./VenueIncidentPanel.vue?vue&type=style&index=0&id=2307bce3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2307bce3"]])

export default __exports__